import { Stack, Tooltip, Typography } from '@mui/material';
import type { AppColumnDef } from '@/components/table/tanstackTable';
import { Tag } from '@/components/tag';
import type { HistoryChangeRow } from './historyChangeRows';
import { HistoryChangeValue } from './historyChangeValue';
import { historyPathLabel } from './historyView';
export const HISTORY_CHANGE_COLUMNS: AppColumnDef<HistoryChangeRow>[] = [{
  id: 'setting',
  header: 'Setting',
  enableSorting: false,
  size: 300,
  cell: ({
    row
  }) => {
    const kind = row.original.kind;
    return <Stack sx={{
      gap: '8px',
      padding: '8px 0px'
    }}>
          <Tooltip title={row.original.context ? `${row.original.context} › ${row.original.label}` : row.original.path}>
            <Typography variant='subtitle2Strong' sx={{
          whiteSpace: 'normal',
          overflowWrap: 'anywhere'
        }}>
              {row.original.label}
            </Typography>
          </Tooltip>
          {row.original.label !== historyPathLabel(row.original.path) && <Typography variant='body2' sx={{
        whiteSpace: 'normal',
        overflowWrap: 'anywhere'
      }}>
              {row.original.context ?? historyPathLabel(row.original.path)}
            </Typography>}
          <Tag content={kind} variant={kind === 'Added' ? 'success' : kind === 'Removed' ? 'error' : 'secondary'} />
        </Stack>;
  }
}, {
  id: 'before',
  header: 'Before',
  enableSorting: false,
  size: 300,
  cell: ({
    row
  }) => <HistoryChangeValue row={row.original} side='before' />
}, {
  id: 'after',
  header: 'After',
  enableSorting: false,
  size: 300,
  cell: ({
    row
  }) => <HistoryChangeValue row={row.original} side='after' />
}];